import Vue from 'vue'
import dayjs from 'dayjs'

Object.defineProperty(Vue.prototype, '$dayjs', { value: dayjs })